import "./UI.css";
import { isOnMobile, SkiSlalomGame } from "../../games/ski-slalom/SkiSlalomGame";
import { Fragment, useState } from "react";
import ReactCountryFlag from "react-country-flag";

export const UI = (props: { game: SkiSlalomGame }) => {
  const [currentTime, setCurrentTime] = useState(0)
  const [penalties, setPenalties] = useState(0)
  const [showTuto, setShowTuto] = useState(false)
  props.game.chrono.onTimeChanges = (time) => {
    setCurrentTime(time)
    setPenalties(props.game.chrono.penalties)
  }

  props.game.onGameFinished = (score: number) => {
    const yourScore = {
      playerName: "TOI",
      score: score,
      countryCode: "FR"
    }
    setLeaderboard([...leaderboard, yourScore])
  }

  const initLeaderboard: { playerName: string, score: number, countryCode: string }[] = [{
    playerName: "Ingemar Stenmark",
    score: 58.20,
    countryCode: "SE"
  }, {
    playerName: "Kjetil André Aamodt",
    score: 65.10,
    countryCode: "NO"
  }, {
    playerName: "Bode Miller",
    score: 69.50,
    countryCode: "US"
  }, {
    playerName: "Alberto Tomba",
    score: 85.12,
    countryCode: "IT"
  },
  {
    playerName: "Lasse Kjus",
    score: 105.45,
    countryCode: "NO"
  },
  {
    playerName: "Marc Girardelli",
    score: 127.85,
    countryCode: "AT"
  },
  {
    playerName: "Hermann Maier",
    score: 136.56,
    countryCode: "AT"
  },
  {
    playerName: "Jean-Claude Killy",
    score: 140.20,
    countryCode: "FR"
  },
  {
    playerName: "Marcel Hirscher",
    score: 145.65,
    countryCode: "AT"
  },
  {
    playerName: "Pirmin Zurbriggen",
    score: 180.45,
    countryCode: "CH"
  }]
  const [leaderboard, setLeaderboard] = useState(initLeaderboard)

  const printPlaceEmoji = () => {
    let placeNumber = leaderboard.sort((a, b) => a.score > b.score ? 1 : -1).findIndex(line => line.playerName === "TOI") + 1;
    if (placeNumber === 1) return "🥇";
    else if (placeNumber === 2) return "🥈";
    else if (placeNumber === 3) return "🥉";
    else return "🏁";
  }

  const printPlace = () => {
    let placeNumber = leaderboard.sort((a, b) => a.score > b.score ? 1 : -1).findIndex(line => line.playerName === "TOI") + 1;
    if (placeNumber === 1) return placeNumber + "ère PLACE !";
    else if (placeNumber === 2) return placeNumber + "nd PLACE !";
    else if (placeNumber === 3) return placeNumber + "ème PLACE !";
    else return placeNumber + "ème PLACE !";
  }

  const firstPlayer = leaderboard.length > 0 ? leaderboard.sort((a, b) => a.score > b.score ? 1 : -1)[0] : undefined;


  const [isFullscreen, setIsFullscreen] = useState<boolean>(false);
  function toggleFullscreen() {
    if (isFullscreen && document.exitFullscreen) document.exitFullscreen();
    else if (!isFullscreen && document.documentElement.requestFullscreen) document.documentElement.requestFullscreen();
    setIsFullscreen(!isFullscreen)
  }


  const sizeRatio = (Math.min(window.innerHeight / 1080, window.innerWidth / 1920));
  return (<div className="ui-container">
    <button onClick={toggleFullscreen} className="tutorial-cta" style={{ top: 0, right: 20, left: "unset", bottom: "unset", padding: "10px 15px" }}>&#x26F6;</button>

    {props.game.finished ?
      <div style={{ height: "100%", display: "flex", overflow: "hidden", flexDirection: "column", justifyContent: "center", padding: 20 }}>
        <div style={{ display: 'flex', gap: 30, justifyContent: "center", marginBottom: 10 }}>
          <h1 className={"title-content spinner-reverse"}>{printPlaceEmoji()}</h1>
          <h1 className={"title-content shadow"}>{printPlace()}</h1>
          <h1 className={"title-content spinner"}>{printPlaceEmoji()}</h1>
        </div>
        <div className="chrono-finished">
          <h2 style={{ margin: 0, textAlign: "right" }}>⏱️ Chronomètre : {String(currentTime.toFixed(2)).padStart(2, '0')}s</h2>
          <h2 style={{ color: "red", margin: 0, textAlign: "right" }}>❌ Pénalités : +{String((penalties).toFixed(2))}s</h2>
          <h1 style={{ margin: 0, textAlign: "right" }}>TOTAL {String((currentTime + penalties).toFixed(2)).padStart(2, '0')}s</h1>
          <button className="restart-btn" onClick={props.game.restart}>Redémarrer</button>
        </div>
        <div className="leaderboard">
          {leaderboard.sort((a, b) => a.score > b.score ? 1 : -1).map((line, lineIndex) => {
            const isPlayer = line.playerName === "TOI";

            let place = String(lineIndex + 1).padStart(2, '0');
            if ((lineIndex + 1) === 1) { place = "🥇"; }
            else if ((lineIndex + 1) === 2) { place = "🥈"; }
            else if ((lineIndex + 1) === 3) { place = "🥉"; }

            return (<div className="row" key={lineIndex} style={{ backgroundColor: isPlayer ? "#ff0000c0" : "" }}>
              <h2 style={{ color: isPlayer ? "white" : "black", margin: 0, textAlign: "left", fontSize: "1.5rem" }}>{place}</h2>
              <h2 style={{ color: isPlayer ? "white" : "black", flexGrow: 1, margin: 0, textAlign: "left", fontSize: "1rem" }}><ReactCountryFlag countryCode={line.countryCode} svg style={{ position: "relative", bottom: 1 }} /> {line.playerName}</h2>
              <h2 style={{ color: isPlayer ? "white" : "black", margin: 0, textAlign: "left", fontSize: "1rem" }}>{String(line.score.toFixed(2)).padStart(2, '0')}s</h2>
              <h2 style={{ color: isPlayer ? "white" : "red", margin: 0, textAlign: "left", fontSize: "1rem" }}>+{String((line.score - firstPlayer!.score).toFixed(2)).padStart(2, '0')}s</h2>
            </div>)
          })}
        </div>
      </div>
      : props.game.gameStarted ? <Fragment>
        <div className="chrono">
          <h2 style={{ margin: 0, textAlign: "right" }}>{String(currentTime.toFixed(2)).padStart(2, '0')}s ⏱️</h2>
          <h2 style={{ color: "red", margin: 0, textAlign: "right" }}>+{String((penalties).toFixed(2))}s ❌</h2>
          <h1 style={{ margin: 0, textAlign: "right" }}>{String((currentTime + (penalties)).toFixed(2)).padStart(2, '0')}s</h1>
        </div>
        <h1 className="speed" style={{ fontSize: Math.min(5 * sizeRatio, Math.max(1.5 * sizeRatio, sizeRatio * (props.game.player!.getSpeed() / 20))) + "rem" }}>⛷️ {props.game.player?.getSpeed().toFixed(1)} km/h</h1>
      </Fragment> : <Fragment>

        <div className={"title"}>
          <h1 className={"title-content spinner-reverse"}>❄️</h1>
          <h1 className={"title-content shadow"}>SKI ALPIN</h1>
          <h1 className={"title-content spinner"} style={{ paddingLeft: 10 }}>⛷️</h1>
        </div>
        {showTuto ? <div className="tutorial">
          <button onClick={() => {
            setShowTuto(false);
          }}>Ok</button>
          <h1 style={{ color: "red", textAlign: "center" }}>📖 Comment jouer ?</h1>
          <div className="tutorial-section">
            <h2 style={{ wordBreak: "break-word" }}>Objectifs</h2>
            <h3 style={{ wordBreak: "break-word" }}>🏁 Finis le slalom en un temps record pour remporter la 1ère place !</h3>
            <h3 style={{ wordBreak: "break-word" }}>⛷️ Suis la ligne bleue pour éviter les pénalités</h3>
          </div>
          <div className="tutorial-section">
            <h2 style={{ wordBreak: "break-word" }}>Contrôles</h2>
            <h3 >⬆️ pour s'accroupir / commencer la course</h3>
            <h3 >⬇️ pour freiner</h3>
            <h3 >⬅️➡️ pour se diriger</h3>
            {!isOnMobile() && <h3>R pour redémarrer</h3>}
          </div>

          <p>🔊🎧 Profites d'une meilleure experience avec un casque</p>
        </div> : <div className="tutorial-cta" onClick={() => {
          setShowTuto(true);
        }}>
          <h1 style={{ textAlign: "center" }}>📖 Comment jouer ?</h1>
        </div>}
      </Fragment>
    }
  </div >)
}